function applyLogoTheme() {
    const isDark = document.documentElement.dataset.theme === 'dark';

    document.querySelectorAll('.a-logo--has-white[data-src-dark]').forEach((img) => {
        const colorSrc = img.getAttribute('data-src-light') || img.src;
        const whiteSrc = img.getAttribute('data-src-dark');

        if (!img.getAttribute('data-src-light')) {
            img.setAttribute('data-src-light', colorSrc);
        }

        img.src = isDark ? whiteSrc : img.getAttribute('data-src-light');
    });
}

// Run on load
applyLogoTheme();

// Watch for theme changes
const observer = new MutationObserver(applyLogoTheme);
observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['data-theme'],
});